import React, { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import CartographyPanel from '../../../../components/map/CartographyPanel'
import QualityAction from 'quality/actions/QualityAction'
import PiezometryAction from 'piezometry/actions/PiezometryAction'
import InstallationAction from 'installation/actions/InstallationAction'
import ProductionUnitAction from 'productionUnit/actions/ProductionUnitAction'
import PluviometryAction from 'pluviometry/actions/PluviometryAction'
import HydrometryAction from 'hydrometry/actions/HydrometryAction'
import ContactAction from 'referencial/components/contact/actions/ContactAction'
import ContributorAction from 'referencial/components/contributor/actions/ContributorAction'
import { CITY_LINK, PATH_REFERENCIAL, PATH_REFERENCIAL_CITY, PATH_REFERENCIAL_CITY_LINK, PATH_REFERENCIAL_RPQS_LINK } from 'home/constants/RouteConstants'
import useTitle from 'utils/customHook/useTitle'
import { useParams } from 'react-router'
import CityAction from '../actions/CityAction'

const CityMapApp = ({ rpqs }) => {
    const { code } = useParams()

    const {
        qualitometersLight,
        piezometersLight,
        installationsLight,
        productionUnits,
        pluviometers,
        hydrometricStations,
        contacts,
        contributors,
        city,
    } = useSelector(store => ({
        city: store.CityReducer.city,
        qualitometersLight: store.QualityReducer.qualitometersLight,
        piezometersLight: store.PiezometryReducer.piezometersLight,
        installationsLight: store.InstallationReducer.installationsLight,
        productionUnits: store.ProductionUnitReducer.productionUnits,
        pluviometers: store.PluviometryReducer.pluviometers,
        hydrometricStations: store.HydrometryReducer.hydrometricStations,
        contacts: store.ContactReducer.contacts,
        contributors: store.ContributorReducer.contributors,
    }), shallowEqual)

    const dispatch = useDispatch()

    useTitle(() => {
        if (rpqs) {
            return [{
                title: i18n.rpqs,
                href: 'rpqs',
            }, {
                title: i18n.RPQSReferencials,
                href: PATH_REFERENCIAL_RPQS_LINK,
            }, {
                title: i18n.towns,
                href: PATH_REFERENCIAL_RPQS_LINK + CITY_LINK,
            }, {
                title: code + (city.name ? ` - ${city.name}` : ''),
                href: PATH_REFERENCIAL_RPQS_LINK + CITY_LINK + code,
            }]
        }
        return [{
            title: i18n.referencials,
            href: PATH_REFERENCIAL,
        }, {
            title: i18n.towns,
            href: PATH_REFERENCIAL_CITY,
        }, {
            title: code + (city.name ? ` - ${city.name}` : ''),
            href: PATH_REFERENCIAL_CITY_LINK + code,
        }]
    }, [code, city, rpqs])

    useEffect(() => {
        dispatch(CityAction.fetchCity(code))
        if (!qualitometersLight.length) {
            dispatch(QualityAction.fetchQualitometersLight)
        }
        if (!piezometersLight.length) {
            dispatch(PiezometryAction.fetchPiezometersLight)
        }
        if (!installationsLight.length) {
            dispatch(InstallationAction.fetchInstallationsLight)
        }
        if (!productionUnits.length) {
            dispatch(ProductionUnitAction.fetchProductionUnits)
        }
        if (!pluviometers.length) {
            dispatch(PluviometryAction.fetchPluviometers)
        }
        if (!hydrometricStations.length) {
            dispatch(HydrometryAction.fetchHydrometricStations)
        }
        if (!contacts.length) {
            dispatch(ContactAction.fetchContacts)
        }
        if (!contributors.length) {
            dispatch(ContributorAction.fetchContributors)
        }
    }, [])

    const getFormattedCode = (list) => list.map(c => ({ ...c, code: c.code?.toString() || '' }))

    const stations = useMemo(() => {
        return [
            ...qualitometersLight,
            ...piezometersLight,
            ...installationsLight,
            ...productionUnits,
            ...pluviometers,
            ...hydrometricStations,
            ...getFormattedCode(contacts),
            ...getFormattedCode(contributors),
        ].filter(s => s.townCode === code)
    }, [contacts, contributors, hydrometricStations, installationsLight, code, piezometersLight, pluviometers, productionUnits, qualitometersLight])

    return (
        <CartographyPanel
            layers={ ['TOWN', 'WATERMASS', 'STATIONS_POINTS'] }
            componentType={ 'referencials' }
            town={ code }
            stationsPoints={ stations }
            stationsPanelTitle={ i18n.stations }
        />
    )
}

CityMapApp.propTypes = {
    rpqs: PropTypes.bool,
}

export default CityMapApp
